// Types para productos
export const OBTENER_PRODUCTOS_EXITO = "OBTENER_PRODUCTOS_EXITO";
export const OBTENER_PRODUCTOS_ERROR = "OBTENER_PRODUCTOS_ERROR";

export const OBTENER_PRODUCTOS_SALIDAS_EXITO =
  "OBTENER_PRODUCTOS_SALIDAS_EXITO";
export const OBTENER_PRODUCTOS_SALIDAS_ERROR =
  "OBTENER_PRODUCTOS_SALIDAS_ERROR";

export const OBTENER_PRODUCTOS_PRESTAMOS_EXITO =
  "OBTENER_PRODUCTOS_PRESTAMOS_EXITO";
export const OBTENER_PRODUCTOS_PRESTAMOS_ERROR =
  "OBTENER_PRODUCTOS_PRESTAMOS_ERROR";

export const ELIMINAR_PRODUCTO = "ELIMINAR_PRODUCTO";  
  export const OBTENER_OBRAS = "OBTENER_OBRAS";
  export const CREAR_OBRA = "CREAR_OBRA";
  export const ACTUALIZAR_OBRA = "ACTUALIZAR_OBRA";
  export const OBRAS_ERROR = "OBRAS_ERROR";

export const OBTENER_PRESTAMOS_ACTIVOS = "OBTENER_PRESTAMOS_ACTIVOS";
export const DEVOLVER_PRESTAMO = "DEVOLVER_PRESTAMO";

export const GET_REPORTE_INGRESOS = "GET_REPORTE_INGRESOS";

export const SET_ERROR = "SET_ERROR";
export const SET_LOADING = "SET_LOADING";

export const OBTENER_USUARIO_EXITO = "OBTENER_USUARIO_EXITO";
export const OBTENER_USUARIO_ERROR = "OBTENER_USUARIO_ERROR";

export const OBTENER_CLIENTE_EXITO = "OBTENER_CLIENTE_EXITO";
export const OBTENER_CLIENTE_ERROR = "OBTENER_CLIENTE_ERROR";

export const OBTENER_USUARIOS_EXITO = "OBTENER_USUARIOS_EXITO";
export const OBTENER_USUARIOS_ERROR = "OBTENER_USUARIOS_ERROR";

export const CREAR_PRODUCTO = "CREAR_PRODUCTO";
export const ACTUALIZAR_PRODUCTO = "ACTUALIZAR_PRODUCTO";

export const OBTENER_CLIENTE_HABILITADO_EXITO =
  "OBTENER_CLIENTE_HABILITADO_EXITO";
export const OBTENER_CLIENTE_HABILITADO_ERROR =
  "OBTENER_CLIENTE_HABILITADO_ERROR";

export const REGISTRAR_SALIDA_REQUEST = "REGISTRAR_SALIDA_REQUEST";
export const REGISTRAR_SALIDA_SUCCESS = "REGISTRAR_SALIDA_SUCCESS";
export const REGISTRAR_SALIDA_FAILURE = "REGISTRAR_SALIDA_FAILURE";

export const OBTENIENDO_PRESTAMOS_EXITO = "OBTENIENDO_PRESTAMOS_EXITO";
export const OBTENIENDO_PRESTAMOS_ERROR = "OBTENIENDO_PRESTAMOS_ERROR";

export const OBTENER_AUTORIZADOS_EXITO = "OBTENER_AUTORIZADOS_EXITO";
export const OBTENER_AUTORIZADOS_ERROR = "OBTENER_AUTORIZADOS_ERROR";
export const CREAR_AUTORIZADO_EXITO = "CREAR_AUTORIZADO_EXITO";
export const CREAR_AUTORIZADO_ERROR = "CREAR_AUTORIZADO_ERROR";
export const ACTUALIZAR_AUTORIZADO_EXITO = "ACTUALIZAR_AUTORIZADO_EXITO";
export const ACTUALIZAR_AUTORIZADO_ERROR = "ACTUALIZAR_AUTORIZADO_ERROR";

// Types para categorías
export const OBTENER_CATEGORIAS_EXITO = "OBTENER_CATEGORIAS_EXITO";
export const OBTENER_CATEGORIAS_ERROR = "OBTENER_CATEGORIAS_ERROR";

export const CREAR_CATEGORIA_EXITO = "CREAR_CATEGORIA_EXITO";
export const CREAR_CATEGORIA_ERROR = "CREAR_CATEGORIA_ERROR";

export const CREAR_PROVEEDOR_EXITO = "CREAR_PROVEEDOR_EXITO";
export const CREAR_PROVEEDOR_ERROR = "CREAR_PROVEEDOR_ERROR";

// Limpiar errores
export const LIMPIAR_ERRORES = "LIMPIAR_ERRORES";

export const CREAR_PRESTAMO_EXITOSO = "CREAR_PRESTAMO_EXITOSO";
export const CREAR_PRESTAMO_ERROR = "CREAR_PRESTAMO_ERROR";

export const FETCH_AUTORIZADOS_REQUEST = "FETCH_AUTORIZADOS_REQUEST";
export const FETCH_AUTORIZADOS_SUCCESS = "FETCH_AUTORIZADOS_SUCCESS";
export const FETCH_AUTORIZADOS_FAILURE = "FETCH_AUTORIZADOS_FAILURE";

export const GET_REPORTE_SALIDAS = "GET_REPORTE_SALIDAS";

export const OBTENER_PROVEEDORES_EXITO = "OBTENER_PROVEEDORES_EXITO";
export const OBTENER_PROVEEDORES_ERROR = "OBTENER_PROVEEDORES_ERROR";

export const CREAR_INGRESO_SUCCESS = "CREAR_INGRESO_SUCCESS";
export const CREAR_INGRESO_ERROR = "CREAR_INGRESO_ERROR";

export const POST_USER = "POST_USER";
export const LOGOUT = "LOGOUT";

export const REQUEST_PASSWORD_RESET = "REQUEST_PASSWORD_RESET";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const SET_USER_EMAIL = "SET_USER_EMAIL";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
